import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { captureReferral } from '../lib/referral';

// The pixel snippet in index.html fires the first PageView; track later in-app page changes.
const usePixelPageViews = (pathname) => {
  const first = useRef(true);
  useEffect(() => {
    if (first.current) { first.current = false; return; }
    if (typeof window.fbq === 'function') window.fbq('track', 'PageView');
  }, [pathname]);
};

// Resets scroll to top on route change; smooth-scrolls to the hash target when present.
export default function ScrollToTop() {
  const { pathname, hash, key, search } = useLocation();
  usePixelPageViews(pathname);

  useEffect(() => {
    captureReferral(search);
  }, [search]);

  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      let tries = 0;
      const t = setInterval(() => {
        const el = document.getElementById(id);
        if (el || ++tries > 20) {
          clearInterval(t);
          el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 50);
      return () => clearInterval(t);
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname, hash, key]);

  return null;
}
